import React, { useState, useCallback, useEffect } from 'react';
import { Input } from "@/components/ui/input";

// Performanslı Input bileşeni - sadece blur'da parent'ı günceller
const DebouncedInput = React.memo(({ 
  value, 
  onChange, 
  ...props 
}) => {
  const [localValue, setLocalValue] = useState(value || '');

  // Parent'tan gelen value değiştiğinde local'i güncelle (form reset için)
  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = useCallback((e) => {
    setLocalValue(e.target.value);
  }, []);

  const handleBlur = useCallback(() => {
    // Sadece blur'da parent'a bildir
    if (localValue !== value) {
      onChange(localValue);
    }
  }, [localValue, value, onChange]);

  // Enter tuşuna basınca da güncelle
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' && localValue !== value) {
      onChange(localValue);
    }
  }, [localValue, value, onChange]);

  return (
    <Input
      {...props}
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    />
  );
});

DebouncedInput.displayName = 'DebouncedInput';

export default DebouncedInput;
